import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { CodeDashboardComponent } from './code-dashboard/code-dashboard.component';
import { DynamicDashboardComponent } from './dynamic-dashboard/dynamic-dashboard.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { catchError, filter, firstValueFrom, map, Observable, of, Subject, takeUntil, tap, timeout } from 'rxjs';
import { DashboardService } from './board.service';
import { MatButtonModule } from '@angular/material/button';
import { SafePipe } from '../../pipes/safe.pipe';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HttpEventType } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { MatDatepickerModule, MatDateRangeInput, MatDateRangePicker } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnalyticsService } from '../../services/analytics.service';
import { APPDB } from '../../recongition-system-api/db';
import { AuthService } from '../../services/auth.service';
import { MainHeaderComponent } from '../shared/main-header/main-header.component';
import { Auth } from '@angular/fire/auth';
import { DEFAULT_MAX_DOWNLOAD_DAYS, getMaxDownloadDays } from './download-limits';
import { resolveUrlTemplate } from './url-template';
import { DashboardItem } from './board.types';


@Component({
  selector: 'app-boards',
  standalone: true,
  imports: [CommonModule, RouterLink, MatButtonModule, SafePipe, MatMenuModule, MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressSpinnerModule,
    CodeDashboardComponent,
    DynamicDashboardComponent,
    MainHeaderComponent
  ],
  templateUrl: './boards.component.html',
  styleUrl: './boards.component.scss'
})
export class BoardsComponent {
  dashboardService = inject(DashboardService)
  isLoading: boolean = false
  snackBar = inject(MatSnackBar)
  route = inject(ActivatedRoute)
  router = inject(Router)
  analytics = inject(AnalyticsService)
  firebaseAuth = inject(Auth)
  rangeForm!: FormGroup;
  maxAllowedDays: number = DEFAULT_MAX_DOWNLOAD_DAYS;

  constructor(
    private _adapter: DateAdapter<Date>
  ) {
  }

  minDate!: Date;
  maxDate!: Date;

  granular$: any = this.dashboardService.granular$
  gestion$: any = this.dashboardService.gestion$
  images$: any = this.dashboardService.images$
  compe$: any = this.dashboardService.competencia$
  dashBoards$!: Observable<any[]>;
  dashboard$!: Observable<any>;
  urlOne: any
  selectedDashboard$ = this.dashboardService.selectedDashboard$;

  isbotTest = false
  activeCalendar: boolean = false
  activeCalendarBtn: boolean = true
  private selectedDashboardId: string | null = null;

  private destroy$ = new Subject<void>();

  dashboardIdFromRoute: any
  clientIdFromQuery: string | null = null;
  render!: string
  missingUrlParams: string[] = [];
  private lastMetabaseFetchKey: string | null = null;
  boardsLoading = true;
  private boardsLoadingStartedAt = Date.now();
  private readonly minSkeletonMs = 700;
  metabaseRows: Record<string, unknown>[] = [];
  metabaseColumns: string[] = [];
  db = inject(APPDB);
  ngOnInit() {
    this.boardsLoading = true;
    this.boardsLoadingStartedAt = Date.now();
    this.user$ = this.auth.userData$.pipe(
      filter((d): d is { client_id: number, rol: boolean } => !!d)
    );

    this.minDate = new Date(2025, 0, 1);
    this.maxDate = new Date(2026, 11, 31);



    this.dashboardIdFromRoute = this.route.snapshot.paramMap.get('id');
    this.clientIdFromQuery = this.route.snapshot.queryParamMap.get('client_id');
    // this.db.getDashL('')
    this.selectedDashboardId = this.dashboardIdFromRoute;

    this.dashboardService.getDashboards().pipe(
      map((dashboards: any[]) => {
        if (!this.dashboardIdFromRoute) {
          console.warn('No se encontró ID de dashboard en la ruta.');
          return null;
        }
        return dashboards.find(d => d.id === this.dashboardIdFromRoute);
      }),
      tap(selected => {
        if (selected) {

          this.urlOne = selected;
          this.dashboardService.setSelectedDashboardUrl(selected);
          this.maxAllowedDays = getMaxDownloadDays(this.firebaseAuth.currentUser?.email);

          if (selected.queries && selected.queries.length > 0 && selected.queries[0].type === 'calendar') {
            this.activeCalendar = true;
            // this.isbotTest = true;
          }
          this.loadMetabaseCardData(selected);
          if (selected.type === 'metabase') {
            if (typeof selected.dashboard === 'number') {
              const fetchKey = `${selected.id}:${selected.dashboard}`;
              if (this.lastMetabaseFetchKey !== fetchKey) {
                this.lastMetabaseFetchKey = fetchKey;
                this.cargarDatos(selected.id, selected.dashboard);
              }
            } else {
              console.warn('No se encontró ID de dashboard de Metabase en el tablero.');
              this.router.navigate(['/boards']);
            }
          } else if (selected.type === 'params') {
            this.renderUrlWithUserParams(selected);
          } else {
            this.render = selected.urlBi;
          }
        } else {
          this.maxAllowedDays = getMaxDownloadDays(this.firebaseAuth.currentUser?.email);
          this.urlOne = null;
          this.activeCalendar = false;
          this.metabaseRows = [];
          this.metabaseColumns = [];
          this.render = '';
        }
        this.finishBoardsLoading();
        this.initializeOrUpdateForm(this.maxAllowedDays);
      }),
      catchError(error => {
        this.maxAllowedDays = getMaxDownloadDays(this.firebaseAuth.currentUser?.email);
        this.urlOne = null;
        this.activeCalendar = false;
        this.metabaseRows = [];
        this.metabaseColumns = [];
        this.finishBoardsLoading();
        this.initializeOrUpdateForm(this.maxAllowedDays);
        return of(null);
      }),
      takeUntil(this.destroy$)
    ).subscribe();

  }

  // El listado ya oculta el tablero si faltan parametros, pero a /boards/:id se
  // puede entrar directo: sin todos los valores no se carga la URL a medias.
  private renderUrlWithUserParams(dashboard: DashboardItem): void {
    const params = this.dashboardService.getParamsForUser(dashboard.parameters, this.dashboardService.currentUid);
    const { url, missing } = resolveUrlTemplate(dashboard.urlBi, params);
    this.missingUrlParams = missing;
    this.render = url ?? '';
  }

  private finishBoardsLoading(): void {
    const elapsed = Date.now() - this.boardsLoadingStartedAt;
    const remaining = Math.max(0, this.minSkeletonMs - elapsed);
    setTimeout(() => {
      this.boardsLoading = false;
    }, remaining);
  }

  private loadMetabaseCardData(dashboard: any): void {
    const cardId = this.extractMetabaseCardId(dashboard);
    if (!cardId) {
      this.metabaseRows = [];
      this.metabaseColumns = [];
      return;
    }

    this.dashboardService.getMetabaseCardJson(cardId).subscribe({
      next: (rows: unknown[]) => {
        const parsedRows = Array.isArray(rows) ? rows as Record<string, unknown>[] : [];
        this.metabaseRows = parsedRows;
        this.metabaseColumns = parsedRows.length > 0 ? Object.keys(parsedRows[0]) : [];
      },
      error: () => {
        this.metabaseRows = [];
        this.metabaseColumns = [];
      }
    });
  }

  private extractMetabaseCardId(dashboard: any): number | null {
    const queries = dashboard?.queries;
    if (!Array.isArray(queries)) {
      return null;
    }

    for (const query of queries) {
      const host = typeof query?.host === 'string' ? query.host : '';
      if (!host) {
        continue;
      }

      const cardId = this.parseCardIdFromHost(host);
      if (cardId) {
        return cardId;
      }
    }

    return null;
  }

  private parseCardIdFromHost(host: string): number | null {
    const match = host.match(/\/api\/card\/(\d+)\/query\/json/);
    if (!match?.[1]) {
      return null;
    }
    const parsed = Number(match[1]);
    return Number.isFinite(parsed) ? parsed : null;
  }
  user$!: Observable<any>;
  loading!: boolean
  auth = inject(AuthService)

  async cargarDatos(uid: string, metabaseDashboardId: number) {
    this.loading = true;
    try {
      // 1. INTENTAR LEER CACHÉ
      const data = await this.db.getDashL(uid);
      const now = Date.now();
      const tenMinutesMs = 10 * 60 * 1000;
      if (data && data.milisec) {
        const tiempoTranscurrido = now - data.milisec;
        if (tiempoTranscurrido < tenMinutesMs) {
          const tiempoRestanteMs = tenMinutesMs - tiempoTranscurrido;
          const minutos = Math.floor(tiempoRestanteMs / 60000);
          const segundos = Math.floor((tiempoRestanteMs % 60000) / 1000);
          this.render = data.render;
          this.loading = false;
          return;
        }
      }

      const nuevaUrl = await firstValueFrom(this.dashboardService.enbedUrl({}, metabaseDashboardId));

      if (data) {
        await this.db.updateDash(uid, nuevaUrl.url);
      } else {
        await this.db.saveDashboard(uid, 'metabase', nuevaUrl.url);
      }
      this.render = nuevaUrl.url;

    } catch (error) {
      console.error('Error cargando dashboard:', error);
    } finally {
      this.loading = false;
    }
  }


  private initializeOrUpdateForm(maxDays: number): void {
    if (this.rangeForm) {
      this.rangeForm.setValidators(this.dateRangeValidator(maxDays));
      this.rangeForm.updateValueAndValidity();
    } else {
      this.rangeForm = new FormGroup({
        start: new FormControl<Date | null>(null, Validators.required),
        end: new FormControl<Date | null>(null, Validators.required)
      }, { validators: this.dateRangeValidator(maxDays) });

      this.rangeForm.valueChanges.pipe(
        takeUntil(this.destroy$)
      ).subscribe(values => {
        this.activeCalendarBtn = !this.rangeForm.valid;
      });
    }
  }
  get startDateControl(): AbstractControl | null {
    return this.rangeForm.get('start');
  }

  get endDateControl(): AbstractControl | null {
    return this.rangeForm.get('end');
  }

  get rangeError() {
    return this.rangeForm.errors && this.rangeForm.errors['maxRangeExceeded'];
  }

  downloadActive: boolean = false
  progress = 0

  formatDate(date: Date | string | null): string {
    if (!date) {
      return '';
    }
    const d = new Date(date);
    const year = d.getFullYear();
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  dateRangeValidator(maxDays: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const startDateVal = control.get('start')?.value;
      const endDateVal = control.get('end')?.value;

      if (startDateVal && endDateVal) {
        // Normalizar fechas a medianoche para una comparación precisa de días
        const startDate = new Date(startDateVal.getFullYear(), startDateVal.getMonth(), startDateVal.getDate());
        const endDate = new Date(endDateVal.getFullYear(), endDateVal.getMonth(), endDateVal.getDate());

        const differenceInTime = endDate.getTime() - startDate.getTime();
        // Sumamos 1 al resultado porque si seleccionas del 1 al 15, la diferencia es 14 días, pero en realidad son 15 días de rango.
        const differenceInDays = (differenceInTime / (1000 * 3600 * 24)) + 1;
        console.log('Difference in days:', differenceInDays); // DEBUG
        if (differenceInDays > maxDays) {
          return { 'maxRangeExceeded': { maxDays: maxDays, actualDays: differenceInDays } };
        }
      }
      console.log('Validator: No error'); // DEBUG
      return null;
    };
  }

  id!: any;

  downloadQueryGzip(d: any, name: string) {


    this.rangeForm.disable();
    if (this.rangeForm.invalid) {
      console.error('El formulario de rango de fechas no es válido.');
      return;
    }

    const hostUrl = d.host || d.params?.host || d.queries?.[0]?.host;

    if (!hostUrl) {
      console.error('No se encontró el campo host en el objeto d:', d);
      this.rangeForm.enable();
      return;
    }

    let clientQueryId: string | null;
    let startDateFromUrl: string | null;
    let endDateFromUrl: string | null;

    try {
      const parsed = new URL(hostUrl.trim());
      clientQueryId = parsed.searchParams.get('client_query_id');
      startDateFromUrl = parsed.searchParams.get('start_date');
      endDateFromUrl = parsed.searchParams.get('end_date');
    } catch (err) {
      console.error('URL inválida:', hostUrl, err);
      this.rangeForm.enable();
      return;
    }

    if (!clientQueryId) {
      console.error('No se encontró client_query_id en la URL:', hostUrl);
      this.rangeForm.enable();
      return;
    }

    const formValues = this.rangeForm.value;
    const startDate = this.formatDate(formValues.start) || startDateFromUrl;
    const endDate = this.formatDate(formValues.end) || endDateFromUrl;

    if (!startDate || !endDate) {
      console.error('Las fechas de inicio o fin no están disponibles en el formulario ni en la URL.');
      this.rangeForm.enable();
      return;
    }

    this.id = clientQueryId;
    console.log(`${this.id}, ${startDate} - ${endDate}`);

    this.downloadActive = true;
    this.isLoading = true;
    this.progress = 0;
    this.activeCalendarBtn = true;
    this.analytics.trackDownloadReport(d.type, d.name, this.dashboardIdFromRoute)

    this.dashboardService.downloadCsv(startDate, endDate, this.id)
      .subscribe({
        next: event => {
          if (event.type === HttpEventType.Response) {
            const contentDisposition = event.headers.get('Content-Disposition') ?? '';
            const filenameMatch = contentDisposition.match(/filename\*\=UTF\-8\'\'(.+)$|filename=\"([^"]+)\"/);
            let filename = filenameMatch ? (filenameMatch[1] || filenameMatch[2]) : `${startDate}-${endDate}-${name}.csv.gz`;
            saveAs(event.body!, filename);

            this.rangeForm.enable();
            this.rangeForm.reset();
            this.progress = 100;
            this.activeCalendarBtn = false;
            this.downloadActive = false;
            this.isLoading = false;
            this.snackBar.open('Descarga completada exitosamente!', 'Cerrar', { duration: 3000 });
          }
        },
        error: err => {
          console.error('Error al descargar CSV', err);
          this.isLoading = false;
          this.rangeForm.enable();
          this.activeCalendarBtn = false;
          this.downloadActive = false;
          this.snackBar.open('Error en la descarga.', 'Cerrar', { duration: 3000 });
        }
      });
  }


  downloadQuery(queryUrl: string, d: any): void {
    this.isLoading = true
    this.snackBar.open('Descargando...', '', { duration: 30000 });

    this.analytics.trackDownloadReport(d.type, d.name, this.dashboardIdFromRoute)

    this.dashboardService.downloadFile(queryUrl)
      .subscribe({
        next: (blob: Blob) => {
          // Crear un enlace de descarga
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'datos.csv';
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;
          this.snackBar.open('Descarga completada', 'Cerrar', { duration: 3000 });
        },
        error: (err) => {
          console.error('Error al descargar el archivo:', err);
          this.isLoading = false;
        },
      });
  }

}
